import { RootPaths } from "@src/appV2/App/paths";

export const STRIPE_ONBOARDING_BASE_PATH = "stripe-onboarding";
export const STRIPE_ONBOARDING_FULL_PATH = `${RootPaths.APP_V2_HOME}/${STRIPE_ONBOARDING_BASE_PATH}`;
